"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const useAnalyticsActivityView = activity => {
  const prev = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    window.dataLayer = window.dataLayer ?? [];
    if (activity && activity.id !== prev.current?.id) {
      window.dataLayer.push({
        ecommerce: null
      });
      window.dataLayer.push({
        event: 'view_item',
        ecommerce: {
          items: [{
            item_category: 'Activiteit',
            item_id: activity?.slug,
            item_name: activity?.name,
            quantity: 1
          }]
        }
      });
    }
  }, [activity]);
};
var _default = exports.default = useAnalyticsActivityView;